import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row flex-sm-up mt-5" }
const _hoisted_2 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 1,
  class: "col-sm-12"
}
const _hoisted_5 = { class: "text-small" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "row flex-sm-up mt-3 mb-4" }
const _hoisted_8 = {
  key: 0,
  class: "col-sm-12 text-right"
}
const _hoisted_9 = { class: "icons-list icons-list--inline icons-list--blue-links v-favorites__sharing" }
const _hoisted_10 = {
  key: 0,
  class: "icons-list__item icons-block"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "sharethis-inline-share-buttons",
  "data-title": "Favorites"
}, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "product-grid mb-5 product-grid--4-col"
}
const _hoisted_14 = {
  key: 1,
  class: "col-12 mb-5 text-center p-3 bg-gray-light"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "load-indicator__indicator" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "load-indicator__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isSharedMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString($data.translations?.MyWishlist), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isSharedMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString($data.translations?.SharedWishlist), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("a", {
                alt: "favorites url",
                href: $options.baseUrl()
              }, "[" + _toDisplayString($data.translations?.ViewMyWishlist) + "]", 9 /* TEXT, PROPS */, _hoisted_6)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      ($data.products.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (!_ctx.isSharedMode)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, _hoisted_12))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", null, [
      ($data.products.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, (product, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: product,
                class: "product-grid__item"
              }, [
                _createVNode(_component_ProductCard, {
                  portfolioType: product.portfolio,
                  url: product.productDetailUrl,
                  title: product.productDisplayName,
                  imageUrl: product.primaryImageUrl,
                  isFinishImageMissing: product.isFinishImageMissing,
                  beautyImageUrl: product.beautyImageUrl,
                  description: product.productBrowseDescription,
                  availability: product.availability,
                  modelNumber: product.modelNumber,
                  index: index,
                  translations: $data.translations,
                  product: product,
                  hasQuickship: product.quickShip,
                  isDiscontinued: product.isDiscontinued,
                  disableComparison: true,
                  onFavoriteItemRemoved: $options.removeFavoriteProduct
                }, null, 8 /* PROPS */, ["portfolioType", "url", "title", "imageUrl", "isFinishImageMissing", "beautyImageUrl", "description", "availability", "modelNumber", "index", "translations", "product", "hasQuickship", "isDiscontinued", "onFavoriteItemRemoved"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($data.translations?.NoSavedProducts), 1 /* TEXT */)),
      _createElementVNode("div", {
        class: _normalizeClass(["load-indicator", { 'state-visible': $data.loadingResults === true }])
      }, [
        _hoisted_15,
        _createElementVNode("span", _hoisted_16, _toDisplayString($data.translations?.Loading), 1 /* TEXT */)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["load-indicator-cover", { 'state-visible': $data.loadingResults === true }])
      }, null, 2 /* CLASS */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}